import Mgr from "@/services/SecurityService";
import http from "@/plugins/http";

let mgr = new Mgr();
export const state = {
  roles: null,
  isAppAdmin: false
};
export const mutations = {
  SET_ROLES(state, val) {
    state.roles = val;
  },
  UPDATE_APP_ADMIN_STATUS(state, data) {
    state.isAppAdmin = data;
  }
};
export const actions = {
  setRoles({ commit }, groups) {
    commit("SET_ROLES", groups);
  },
  async isAppAdmin({ commit }) {
    try {
      let response = await http.get(`visp/IsAppAdmin`);
      commit(`UPDATE_APP_ADMIN_STATUS`, response.data);
      return Promise.resolve(response.data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  }
};
export const getters = {
  isAdmin: state => {
    return state.roles && state.roles.includes("VispAdmin");
  },
  isAppAdmin: state => {
    return state.isAppAdmin;
  },
  isAllowed: state => {
    return state.roles && state.roles.includes("Vis");
  }
};
